import script from "./control.vue?vue&type=script&lang=js"
export * from "./control.vue?vue&type=script&lang=js"

import "./control.vue?vue&type=style&index=0&id=2ea0e0e7&lang=css"

const __exports__ = script;

export default __exports__